module.exports = __webpack_public_path__ + "img/pruebas_nacionales_placeholder.18c3429c.png";